<template>
  <sessions-list-wrapper
    v-bind:key="loading"
    v-bind:sessions_list="sessionsToAnimate"
    title="Prochaines sessions"
    no_result="Vous n'avez aucune session à venir."
    has_positionnement_modal
    v-bind:current_space="'stagiaire'"
    v-on:fetch-sessions="fetchSessions"
    v-bind:loading="loading"
    v-bind:active_space="activeSpaceId" />
</template>
<script>
  import { API } from '@/http-common';
  import sessionsListWrapper from '../utils/sessions-list-wrapper.vue';

  export default {
    components: { sessionsListWrapper },
    props: ['props'],
    data: () => ({
      loading: false,
      sessionsToAnimate: null
    }),
    computed: {
      activeSpaceId() {
        return this.$route.params.space_id;
      },
      stagiaire_famille_context() {
        return this.activeSpaceId === 'stagiaire'
          ? 'familleStage'
          : 'familleStageCAC';
      }
    },
    created() {
      this.fetchSessions();
    },
    methods: {
      async fetchSessions() {
        this.loading = true;
        const response = await API.get(
          'participant/prochaines-sessions',
          this.$header_skip_redirection
        );

        this.sessionsToAnimate = response.data
          ? response.data.filter((s) => s[this.stagiaire_famille_context])
          : [];
        this.loading = false;
      }
    }
  };
</script>
